import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IState } from './state.interface';
import { getSharedState } from './state.selector';

@Injectable({
  providedIn: 'root',
})
export class StateFacade {
  public aggregatedState$ = this.store.select(getSharedState);

  constructor(private store: Store<IState>) {}
}
